// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"96eca768","990":"46d60b32"}[chunkId] + ".chunk.js";
};